import { useCallback, useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { OnSubmit } from '../../../forms/TwinForm/types';
import { changeErrorMessage } from '../../reducers/reduxDispatch';
import useTwinTranslation from '../useTwinTranslation';
import referenceGeneration, { generateReferenceWithCheck } from '../../globals/referenceGeneration';
import { OnChangeMainCategoryTy } from '../../../baseComponents/Product/ProductCategories/types';
import { flushSync } from 'react-dom';
import { RowData } from '../../../baseComponents/TwinTable/types';
import { ImageInputFile } from '../../../forms/ImageInput/types';

interface ModalCreateProductLogicProps {
    customLocation?: string
    onSubmit?: OnSubmit
    navigateToProduct?: boolean
    allRowData?: RowData
}
const useModalCreateProductLogic = ({ customLocation, onSubmit, navigateToProduct, allRowData }: ModalCreateProductLogicProps ) => {
    const [reference, setReference] = useState(() => allRowData?.reference || referenceGeneration({ CategoryId: allRowData?.CategoryMainId || 1 }).reference)
    const [selectedCategory, setSelectedCategory] = useState<number | null>(allRowData?.CategoryMainId || null)
    const [copyImages, setCopyImages] = useState<boolean>(allRowData?.id ? true : false)
    const [files, setFiles] = useState<ImageInputFile[]>(allRowData?.ProductImages?.[0]?.url ? [{ name: allRowData?.ProductImages?.[0]?.url, preview: allRowData?.ProductImages?.[0]?.url }] : []);
    const navigate = useNavigate();
    const location = useLocation().pathname;
    const { t } = useTwinTranslation()

    const handleOnSubmit: OnSubmit = useCallback(async (res: Response) => {
        const data = await res.json()
        onSubmit?.(data, {})
        if (navigateToProduct) {
            navigate((customLocation || location) + '/' + data.id + '/main')
        }
    }, [navigate, location, customLocation, onSubmit, navigateToProduct])

    const errorReference = t('referenceAlreadyExists', 'La referencia ya existe')
    const errorCodebar = t('codebarAlreadyExists', 'El código de barras ya existe')
    const handleOnError: OnSubmit = useCallback(async (res: Response) => {
        const responseJSON = await res.json()
        if (responseJSON.errors[0].msg === 'This reference already exists') {
            changeErrorMessage(errorReference)
        } else if (responseJSON.errors[0].msg === 'This codebar already exists') {
            changeErrorMessage(errorCodebar)
        } else {
            changeErrorMessage(responseJSON.errors[0].msg)
        }
    }, [errorReference, errorCodebar])

    const onChangeMain: OnChangeMainCategoryTy = useCallback((CategoryId) => {
        let myCategoryId = 0
        flushSync(async () => {
            await setReference((oldRef: any) => {
                const result = generateReferenceWithCheck({ CategoryId }, oldRef)
                if (result.CategoryId) {
                    myCategoryId = result.CategoryId
                }
                
                return result.reference
            })
            setSelectedCategory(myCategoryId)
        })
    }, [])

    const handleCopyImages = useCallback((value: any) => {
        setCopyImages(value)
        if (value === false) {
            setFiles([])
        } else {
            setFiles([{ name: allRowData?.ProductImages?.[0]?.url, preview: allRowData?.ProductImages?.[0]?.url }])
        }
    }, [allRowData?.ProductImages, setFiles, setCopyImages ])
    
    return { handleOnSubmit, handleOnError, onChangeMain, reference, setReference, selectedCategory, copyImages, files, setFiles, handleCopyImages }
}

export default useModalCreateProductLogic